import { useQuery } from '@apollo/client';
import type { UseOrganizationFetch } from '@openx/components-organization/lib/utils/context/OrganizationHookTypes';
import type { DspRestrictionModes, OrganizationType } from '@openx/types/organization';
import { GetOrganizationDocument } from '../../../graphql/query/organizations/GetOrganization.generated';

export const useOrganizationFetch: UseOrganizationFetch = accountId => {
  const {
    data: { account_by_pk: organization } = {},
    loading,
    refetch,
  } = useQuery(GetOrganizationDocument, { fetchPolicy: 'no-cache', skip: !accountId, variables: { id: accountId } });

  const organizationTyped = organization
    ? {
        ...organization,
        organization_type: organization.organization_type as OrganizationType,
        dsp_restriction_mode: (organization.dsp_restriction_mode ?? undefined) as DspRestrictionModes | undefined,
        dsp_restriction: organization.dsp_restriction ?? undefined,
      }
    : undefined;

  return {
    loading,
    organization: organizationTyped,
    refetch,
  };
};
